import Component from './Component';

export default class SubMenu extends Component {
    load() {
        this.initNavigateOnChange();
        this.toggleSubMenu();

        super.load();
    }

    initNavigateOnChange() {
        $(".banner__subnav__select-new").on('change', function (e) {
            window.location = $(this).val();
        });

        $(".subcategoryNavigation").on('change', function (e) {
            window.location = $(this).val();
        });
    }

    toggleSubMenu() {
        const navBuilder = document.querySelector(".nav-builder");
        const subMenus = document.querySelectorAll(".navBuilder__submenu");
        const tripPlanner = document.querySelectorAll(".nav-builder__trip-plan-mobile");
        const tripPlannerMiddle = document.querySelectorAll(".nav-builder__trip-plan-middle");

        if (!navBuilder) return;

        const updateVisibility = () => {
            const isOpen = navBuilder.classList.contains("open") || navBuilder.classList.contains("expanded");
            const windowWidth = window.innerWidth;

            subMenus.forEach(subMenu => {
                if (!isOpen) {
                    subMenu.classList.add("active");
                    subMenu.style.display = "flex";
                }
                else {
                    subMenu.classList.remove("active");
                    subMenu.style.display = "none";
                }
            });

            const isSubMenuActive = Array.from(subMenus).some(subMenu => subMenu.classList.contains("active"));

            if (isSubMenuActive && windowWidth > 640 && windowWidth < 1300) {
                tripPlanner.forEach(el => el.style.display = "none");
                tripPlannerMiddle.forEach(el => el.style.display = "flex");
            } else {
                tripPlanner.forEach(el => el.style.display = "flex");
                tripPlannerMiddle.forEach(el => el.style.display = "none");
            }
        };

        updateVisibility();

        const observer = new MutationObserver(updateVisibility);
        observer.observe(navBuilder, { attributes: true, attributeFilter: ["class"] });

        window.addEventListener("resize", updateVisibility);
    }
}
